const cellHead = { border: "1px solid #d6d3d1", padding: "6px 10px", textAlign: "left", fontSize: 12 };
const cell = { border: "1px solid #d6d3d1", padding: "6px 10px", fontSize: 13 };
const fmt = (n) => `$${(n || 0).toFixed(2)}`;

function Tile({ label, value, tone }) {
  const color = tone === "red" ? "text-red-700" : tone === "muted" ? "text-stone-600" : "text-brand-red";
  return (
    <div className="bg-stone-100 rounded-lg p-2">
      <div className="text-[10px] uppercase tracking-widest text-stone-500">{label}</div>
      <div className={`text-xl font-black ${color}`}>{value}</div>
    </div>
  );
}

export function SquareRegisterSection({ square }) {
  const sq = square || {};
  return (
    <section data-testid="pos-shift-square-section" className="mt-5">
      <h3 style={{ fontSize: 14, margin: "0 0 6px" }} className="flex items-center gap-2">
        Square register
        {sq.environment === "sandbox" && (
          <span className="text-[10px] uppercase tracking-widest text-amber-700 bg-amber-100 rounded-full px-2 py-0.5">sandbox</span>
        )}
      </h3>
      {!sq.configured ? (
        <p className="text-xs text-stone-500" data-testid="pos-shift-square-unavailable">Square isn&apos;t connected, so no register sales to show.</p>
      ) : !sq.ok ? (
        <p className="text-xs text-red-700" data-testid="pos-shift-square-error">Couldn&apos;t reach Square for this day: {sq.error}</p>
      ) : (
        <>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 text-center">
            <Tile label="Payments" value={sq.payment_count} />
            <Tile label="Collected" value={fmt(sq.gross)} />
            <Tile label="Tips" value={fmt(sq.tips)} />
            <Tile label="Refunds" value={`− ${fmt(sq.refunds)}`} tone={sq.refunds ? "red" : "muted"} />
          </div>
          <div className="text-[11px] text-stone-500 mt-2" data-testid="pos-shift-square-net">
            Tax collected {fmt(sq.tax)} · Discounts {fmt(sq.discounts)} · Net after refunds <b>{fmt(sq.net)}</b>
          </div>
          <table className="w-full text-sm mt-3" style={{ borderCollapse: "collapse" }} data-testid="pos-shift-square-tender-table">
            <thead>
              <tr style={{ background: "#f5f5f4" }}>
                <th style={cellHead}>Tender</th>
                <th style={cellHead}>Payments</th>
                <th style={cellHead}>Collected</th>
              </tr>
            </thead>
            <tbody>
              {[["card", "Card"], ["cash", "Cash"], ["other", "Other"]]
                .filter(([k]) => sq.by_tender?.[k]?.count)
                .map(([k, label]) => (
                  <tr key={k}>
                    <td style={cell}>{label}</td>
                    <td style={cell}>{sq.by_tender[k].count}</td>
                    <td style={cell}>{fmt(sq.by_tender[k].gross)}</td>
                  </tr>
                ))}
              {!sq.payment_count && (
                <tr><td colSpan={3} style={{ ...cell, textAlign: "center", color: "#888" }}>No Square payments.</td></tr>
              )}
            </tbody>
          </table>
          {sq.by_item?.length > 0 && (
            <>
              <h4 className="text-xs text-stone-600 mt-3 mb-1">Square items sold ({sq.by_item.length})</h4>
              <table className="w-full text-sm" style={{ borderCollapse: "collapse" }} data-testid="pos-shift-square-items-table">
                <thead>
                  <tr style={{ background: "#f5f5f4" }}>
                    <th style={cellHead}>Item</th>
                    <th style={cellHead}>Qty</th>
                    <th style={cellHead}>Gross</th>
                  </tr>
                </thead>
                <tbody>
                  {sq.by_item.map((r, i) => (
                    <tr key={i}>
                      <td style={cell}>{r.name}</td>
                      <td style={cell}>{r.qty}</td>
                      <td style={cell}>{fmt(r.gross)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
        </>
      )}
    </section>
  );
}
